export default __webpack_public_path__ + "static/media/ico-tornar.61e035d2.svg";